/** Shared domain types. Imported by both the server and the client. */
/** Bracket sizes are powers of two only. Byes are an experimental flag. */
export const BRACKET_SIZES = [8, 16, 32];
export const DEFAULT_SETTINGS = {
    gameLayout: 'legacy',
    bracketSize: 16,
    seedingMode: 'no_self_clash',
    // Host-side by default: YouTube serves unblockable ads on embeds, which
    // desynchronises anyone without an adblocker, and Spotify playback needs a
    // logged-in account per listener. One browser playing for the room sidesteps
    // both. See the plan, section 7.3.
    audioMode: 'host_only',
    operatorMode: 'host',
    pauseMode: 'anyone',
    startThreshold: 'all',
    tieRule: 'tiebreak_round',
    // The submitter picking the moment beats any heuristic, and it makes
    // submitting an act of advocacy rather than pasting a link. The slider is
    // seeded with the smart guess, so leaving it alone is still better than
    // starting every song at zero.
    clipMode: 'submitter_choice',
    // Round one should be decided on a listen. The operator can still open the
    // ballot early on any individual match, which is what later rounds want.
    votingOpens: 'after_both',
    // Entries play from wherever they came from. Only the host needs a Spotify
    // session, and only for the Spotify ones.
    spotifyLinks: 'play_on_spotify',
    showBracket: false,
    clipLengthMs: 60_000,
    allowSelfVote: true,
    spectatorsVote: true,
    anonymousUntilEnd: false,
    wildcardRevival: false,
    greatMindsMerge: false,
    allowByes: false,
    themePrompt: null,
    chatMode: 'emoji_only',
    reactionsEnabled: true,
    reactionCooldownMs: 2_000,
    superReactionsEnabled: false,
    superReactionsPerPlayer: 1,
    clipLengthEnabled: true,
    guessingMode: false,
};
/** Drift beyond this triggers a hard seek. See the plan, section 7.3. */
export const DRIFT_DEAD_ZONE_MS = 250;
export const DRIFT_CHECK_INTERVAL_MS = 400;
export const SCHEDULED_START_LEAD_MS = 800;
export const READY_GATE_TIMEOUT_MS = 10_000;
//# sourceMappingURL=types.js.map